export const BUILT_IN_VALIDATIONS_VALIDATION_ROUND_COUNTER_KEY: string = "validationRoundCounter";

export const POLAND: string = "PL";

export const GERMANY: string = "DE";